module.exports = __webpack_public_path__ + "img/$PAC.88f1aba5.svg";